import Indicator from "components/indicator";
import { timestamp } from "lib/date";
import {
  EmailEventType,
  ListInvitationEmailEvent,
} from "models/list-invitation-email-event";
import { Fragment, FunctionComponent } from "react";
import { useTranslate } from "stores/hooks/translation";

interface EventsListProps {
  listInvitationEmailEvents: ListInvitationEmailEvent[];
}

const NEGATIVES: EmailEventType[] = ["bounce", "reject", "complaint"];

const EventsList: FunctionComponent<EventsListProps> = ({
  listInvitationEmailEvents,
}) => {
  const translate = useTranslate();
  return (
    <Fragment>
      {listInvitationEmailEvents.map((event) => {
        const { uuid, type, timestamp: event_timestamp } = event;
        return (
          <Indicator
            key={uuid}
            type={NEGATIVES.includes(type) ? "negative" : "positive"}
          >
            {timestamp(event_timestamp)}:{" "}
            {translate(`email_event_type_${type}`)}
          </Indicator>
        );
      })}
    </Fragment>
  );
};

export default EventsList;
